export default {
  /**
   * Serializes a target definition to JSON
   * @param definition
   */
  serialize(/* TargetDefinition */ definition) {
    if (!definition) return []
    return serializeChildren(definition.children)
  },

  deserialize(/* String */ serializedDefinition = [], storeGetters) {
    return parse(serializedDefinition, storeGetters)
  },
}

function parse(definition, storeGetters) {
  return definition.map(part => {
    if (part.id !== undefined) {
      let attribute
      if (storeGetters) {
      } else {
        attribute = part
      }
      attribute.value = part.value
      return attribute
    }
    if (Array.isArray(part)) {
      // if the array is a count group return with an extra property
      if (typeof part[0] === 'number' && part[1] === 'MIN') {
        return {
          mustMatch: part[0],
          children: parse(part.slice(2), storeGetters),
        }
      }
      return {
        children: parse(part, storeGetters),
      }
    }
    if (typeof part === 'string') {
      return {
        operator: true,
        value: part,
      }
    }
    return null
  })
}

function serializeChildren(definition) {
  return definition.reduce((parts, part) => {
    if (typeof part === 'number' || part === 'MIN') parts.push(part)
    if (part.operator) parts.push(part.value)
    if (part.type !== undefined) {
      parts.push(serializeAttribute(part))
    }
    if (part.mustMatch) parts.push(serializeChildren([Number(part.mustMatch), 'MIN', ...part.children]))
    else if (part.children) parts.push(serializeChildren(part.children))
    return parts
  }, [])
}

function serializeAttribute({
  id,
  value,
  dataset,
  rootFamily,
  path,
  parent,
  name,
  type,
  query,
  isLal,
  advertiserId,
  brdOwner,
  subCategory,
}) {
  return { id, value, dataset, rootFamily, path, parent, name, type, query, isLal, advertiserId, brdOwner, subCategory }
}



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/targetDefinition/services/serializer.js